import React from 'react';
import './PriceList.scss';

function PriceList() {
  const packages = [
    {
      title: "Pack Basic",
      price: "5",
      description: "Pour débuter sur Twitch",
      features: [
        "1 Emote personnalisée",
        "Format Twitch/Discord/Youtube/Tiktok",
        "1 révision gratuite",
        "Livraison sous 1-3 jours"
      ],
      popular: false
    },
    {
      title: "Pack Standard", 
      price: "25",
      description: "Pour les streamers réguliers",
      features: [
        "5 Emotes personnalisées",
        "Formats Twitch/Discord/Youtube/Tiktok",
        "1 révision gratuite pour chaque emote", 
        "Livraison sous 3-5 jours",
      ],
      popular: true
    },
    {
      title: "Pack Premium",
      price: "50", 
      description: "Pour une identité visuelle complète",
      features: [
        "5+ Emotes personnalisées",
        "Formats Twitch/Discord/Youtube/Tiktok",
        "1 révision gratuite pour chaque emote",
        "Livraison sous 1-2 semaines",
      ],
      popular: false
    }
  ];

  return (
    <div className="price-list">
      <div className="price-list-header">
        <h2>Mes Tarifs</h2>
        <p>Des forfaits adaptés à vos besoins</p>
      </div>

      <div className="packages-grid">
        {packages.map((pkg, index) => (
          <div key={index} className="package-card animate-fadeInUp">
            {pkg.popular && <span className="popular-badge">Populaire</span>}
            <div className="package-header">
              <h3>{pkg.title}</h3>
              <div className="price">
                <span className="currency">€</span>
                {pkg.price}
              </div>
              <p className="description">{pkg.description}</p>
            </div>

            <ul className="features-list">
              {pkg.features.map((feature, i) => (
                <li key={i}>{feature}</li>
              ))}
            </ul>
          </div>
        ))}
      </div>

      <div className="faq-section">
        <h3>Questions Fréquentes</h3>
        <div className="faq-grid">
          {[
            {
              question: "Combien de temps prend une commande ?",
              answer: "Le délai de livraison dépend du forfait choisi, allant de 3-5 jours pour le Pack Standard à 1-2 semaines pour le Pack Premium."
            },
            {
              question: "Quel format recevrai-je ?", 
              answer: "Toutes les emotes sont livrées au format PNG en 500x500 pixels, parfaitement optimisées pour les plateformes de streaming."
            },
            {
              question: "Comment sont créées les emotes ?",
              answer: "Je crée toutes mes emotes à 100% sur Procreate, ce qui me permet d'obtenir un style unique et une qualité professionnelle."
            },
            {
              question: "Comment fonctionnent les révisions ?",
              answer: "Chaque emote inclut une révision gratuite. Des révisions supplémentaires peuvent être demandées moyennant des frais additionnels."
            },
            {
              question: "Comment passer commande ?",
              answer: "Rendez-vous dans le menu et cliquez sur \"Commander\" pour effectuer votre paiement via PayPal, ou contactez-moi directement via la section \"Contact\"."
            }
          ].map((item, index) => (
            <div key={index} className="faq-item" onClick={() => {
              const answer = document.querySelector(`#faq-answer-${index}`);
              const question = document.querySelector(`#faq-question-${index}`);
              answer.classList.toggle('active');
              question.classList.toggle('active');
            }}>
              <h4 id={`faq-question-${index}`}>{item.question}</h4>
              <p id={`faq-answer-${index}`}>{item.answer}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default PriceList;